// features/employee/fund/components/EligibilityConditionFields.jsx
import { Col, Form, InputNumber, Radio, Row, Select, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styles from "../styles/EmployeeFund.module.css";
import { CRITERIA_BASIS, TIME_UNIT, getConditionDurationLabel, toOptions } from "../schemas/EmployeeFundSchemas";
import { useMemo } from "react";
import dayjs from "dayjs";
import { FormDatePicker, FormInput } from "components/form/FormProvide";

/**
 * namePrefix: e.g. ["membershipEligibility"] or ["contributionEligibility"]
 * title: section heading, e.g. "เงื่อนไขการมีสิทธิเป็นสมาชิกกองทุน"
 */
const EligibilityConditionFields = ({ namePrefix, title, tooltip, disabled }) => {
    const { t, i18n } = useTranslation();
    const form = Form.useFormInstance();
    const contributionRateCriteria = Form.useWatch([...namePrefix, "contributionRateCriteria"], form);
    const conditionType = Form.useWatch([...namePrefix, "conditionType"], form);
    const durationUnit = Form.useWatch([...namePrefix, "durationUnit"], {
        form,
        preserve: true,
    });
    const durationLabel = getConditionDurationLabel(conditionType, i18n.language);
    const duration = toOptions(TIME_UNIT, i18n.language).find(o => o.value == durationUnit)?.label;

    return (
        <div className={styles.conditionCard}>
            <Row align="middle" gutter={4} style={{ marginBottom: 12 }}>
                <span style={{ fontWeight: 600 }}>{title}</span>
                {tooltip && (
                    <Tooltip title={tooltip}>
                        <InfoCircleOutlined style={{ color: "#98A2B3", marginLeft: 6 }} />
                    </Tooltip>
                )}
            </Row>

            <div style={{ marginBottom: 4, color: "#667085", fontSize: 13 }}>
                {t("employeeFund.label.conditionType") || "ประเภทเงื่อนไข"}
            </div>
            <Form.Item name={[...namePrefix, "conditionType"]} rules={[{ required: true, message: t("employeeFund.label.conditionType") }]}>
                <Radio.Group disabled options={toOptions(CRITERIA_BASIS, i18n.language)} />
            </Form.Item>

            {/* duration + unit sit right before the start date, in the same row */}
            <Row gutter={16}>
                <Col span={12}>
                    <FormDatePicker
                        label={t("employeeFund.label.effectiveStartDate") || "เริ่มต้นวันที่"}
                        name={[...namePrefix, "effectiveStartDate"]}
                        required
                        disabled={disabled}
                        format="DD/MM/YYYY" onChange={(e) => {
                            form.setFieldValue([...namePrefix, "duration"], Math?.abs(e?.diff(dayjs(), durationUnit == 'YEAR' ? 'year' : 'month')) || 0)
                        }}
                    >
                    </FormDatePicker>
                </Col>
                <Col span={12}>
                    <Row gutter={8} align="bottom">
                        <Col flex="100px">
                            <FormInput
                                label={durationLabel}
                                name={[...namePrefix, "duration"]}
                                // rules={[{ required: true, message: "" }]}
                                style={{ marginBottom: 0 }}
                                disabled min={0} controls={false}
                                suffix={duration}
                            >
                            </FormInput>
                        </Col>
                        {/* <Col flex="auto">
                            <Form.Item
                                name={[...namePrefix, "durationUnit"]}
                                rules={[{ required: true, message: "" }]}
                                style={{ marginBottom: 0 }}
                            >
                                <Select options={toOptions(TIME_UNIT, i18n.language)} />
                            </Form.Item>
                        </Col> */}
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default EligibilityConditionFields;
